import { Component } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-dashboard-main',
  standalone: true,
  imports: [],
  templateUrl: './dashboard-main.component.html',
  styleUrl: './dashboard-main.component.scss'
})
export class DashboardMainComponent {
  userPoints: number | null = null;
  errorMessage: string = '';
  referral_hash = document.cookie.split('; ').find(row => row.startsWith('referral_hash='))?.split('=')[1];   

  constructor(private http: HttpClient) {
    this.fetchUserPoints();
  }

  fetchUserPoints() {
    const accessToken = this.getCookie('access_token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`
    });

    this.http.get(`${environment.url}/api/user/points`, { headers }).subscribe({
      next: (response: any) => {
        this.userPoints = response.points;
      },
      error: (error: any) => {
        console.error('Error fetching user points:', error);
        this.errorMessage = 'An error occurred while fetching user points.';
      }
    });
  }

  private getCookie(name: string): string | null {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }
}
